import { useState } from 'react'
import { AppIcon  } from '@/shared/ui/icons'

import _ from 'lodash'
import { useTranslation } from '@/shared/hooks/useTranslation'

import { Button } from '@/shared/ui'
import { ErrorMessage, FormControl, FormGroup, InputGroup } from '@/shared/ui/Form'

import { validationSchema } from './validationSchema'

export const DigitalProductMyProfileEmails = ({ name = 'email' }) => {
  const { t } = useTranslation()
  const [showCurrentPassword, setShowCurrentPassword] = useState(false)

  return (
    <div>
      <FormGroup
        label="E-mail"
        name={name}
        control={FormControl}
        type="email"
        required
        solid
        vertical
      />

      <FormGroup
        label="Senha"
        className="relative"
        required
        vertical
      >
        <InputGroup>
          <FormControl
            name="current_password"
            type={showCurrentPassword ? 'text' : 'password'}
            solid
            required
          />
          <Button
            type="button"
            variant="light"
            icon
            size="lg"
            leadingIcon={
              <AppIcon name={showCurrentPassword ? 'eye' : 'eye-slash'} />
            }
            className="shrink-0 rounded-none border-0"
            onClick={() => setShowCurrentPassword(prevState => !prevState)}
            aria-label={showCurrentPassword ? 'Ocultar senha' : 'Mostrar senha'}
          />
        </InputGroup>
        <ErrorMessage name="current_password" />
      </FormGroup>
    </div>
  )
}

DigitalProductMyProfileEmails.validationSchema = validationSchema

